module.exports = __webpack_public_path__ + "img/img2.05759b61.webp";